export default "__VITE_ASSET__DSWuBIYp__"